export const overrides = {
    MuiDialogActions: {
        root: {
            padding: '16px 24px'
        }
    },
    MuiDialogTitle: {
        root: {
            display: 'flex',
            paddingTop: 20,

            '& .NeptuneDialogTitle-title': {
                display: 'flex',
                flex: '1 1 48px',
                paddingTop: 6
            },
            '& .NeptuneDialogTitle-close': {
                margin: '-8px -12px 0 0'
            }
        }
    }
};
